import { Resolver } from '@apollo/client/core/LocalState';

// eslint-disable-next-line @typescript-eslint/ban-types
type ArgumentTypes<F extends Function> = F extends (...args: infer A) => unknown ? A : never;
export const createResolver = (
    handler: (...args: ArgumentTypes<Resolver>) => unknown,
): Resolver => (...args: ArgumentTypes<Resolver>) => {
    try {
        return handler(...args);
    } catch (e: unknown) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
